import { render, staticRenderFns } from "./bot-secret.vue?vue&type=template&id=b2246b32&scoped=true"
import script from "./bot-secret.vue?vue&type=script&lang=ts"
export * from "./bot-secret.vue?vue&type=script&lang=ts"
import style0 from "./bot-secret.vue?vue&type=style&index=0&id=b2246b32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2246b32",
  null
  
)

export default component.exports